module.exports = __webpack_public_path__ + "static/media/team-1.53033970.jpg";